import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of Orders.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListTranslationPage - Lazy-loaded ListOrdersPage component.
 */
const ListOrders = Loadable(lazy(() => import("./ListOrdersPage")));

/**
 * Array containing route definitions for the Orders-related pages.
 * @constant {Object[]} OrdersPageRoutes - Array of Orders route objects.
 * @property {React.ReactElement} OrdersPageRoutes[].element - The React element to be rendered for the Orders route.
 */
const OrdersPageRoutes = [
  {
    path: "list",
    element: <ListOrders />,
  },
];

export default OrdersPageRoutes;
